<template>
	<div class="popaminatsty boxsizing" @click.stop>
		<div class="titleposty">{{type==1?'考试时间到':'提交试卷'}}</div>
		<!-- {{type==1?'剩余时间 00:00':'剩余时间 35:00'}} -->
		<div class="centsposty" v-if="type==1">剩余时间00:00</div>
		<div class="centsposty" v-if="type==2">剩余时间{{submitInfo.timeLeft}}</div>
		<div class="teinfosty filxcenter">
			<!-- <div class="singlesty">
				<div class="numbsinsty">{{submitInfo.successNum}}</div>
				<div class="titltextsty">正确</div>
			</div>
			<div class="singlesty lineheisty">
				<div class="numbsinsty">{{submitInfo.errorNum}}</div>
				<div class="titltextsty">错误</div>
			</div> -->
			<div class="singlesty lineheisty">
				<div class="numbsinsty">{{submitInfo.successNum+submitInfo.errorNum}}</div>
				<div class="titltextsty">已答题</div>
			</div>
			<div class="singlesty">
				<div class="numbsinsty">{{submitInfo.notNum}}</div>
				<div class="titltextsty">未答题</div>
			</div>
		</div>
		<div class="btnfootsty filxcenter">
			<template v-if="type==2">
				<el-button class="submitonsty boxsizing" @click="continueFun()">继续答题</el-button>
				<el-button class="submitwosty boxsizing" @click="submitFun()">立即交卷</el-button>
			</template>
			<el-button v-else class="submitsty" @click="seeFun()">查看测试结果</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "popopsty",
		props: ['type', 'submitInfo'],
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {
			//继续答题
			continueFun() {
				this.$parent.close()
			},
			//提交
			submitFun() {
				this.$parent.getSubmitFun();

			},
			//查看测试结果
			seeFun() {
				this.$parent.ViewResultsFun();
			}
		},
		watch: {

		},
	};
</script>

<style scoped>
	.popaminatsty {
		padding: 52px 42px;
	}

	.titleposty {
		height: 44px;
		font-size: 30px;
		font-weight: 700;
		line-height: 44px;
		text-align: center;
		margin-bottom: 20px;
		color: rgba(0, 0, 0, 1);
	}

	.centsposty {
		width: 100%;
		height: 24px;
		font-size: 16px;
		font-weight: 400;
		line-height: 24px;
		text-align: center;
		margin: 11px 0px 49px;
		color: rgba(51, 51, 51, 1);
	}

	.teinfosty {
		width: 100%;
		height: 80px;
		border-radius: 10px;
		background: rgba(247, 249, 251, 1);
	}

	.singlesty {
		position: relative;
		flex: 1;
		height: 50px;
		text-align: center;
	}

	.numbsinsty {
		height: 30px;
		font-size: 20px;
		font-weight: 700;
		line-height: 29px;
		color: rgba(51, 51, 51, 1);
	}

	.titltextsty {
		height: 20px;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(153, 153, 153, 1);
	}


	.lineheisty::before {
		position: absolute;
		content: '';
		width: 1px;
		height: 20px;
		top: 15px;
		background: rgba(204, 204, 204, 1);
	}

	.lineheisty::after {
		left: 0px;
	}

	.lineheisty::before {
		right: 0px;
	}

	.btnfootsty {
		margin-top: 41px;
	}

	.submitsty,
	.submitwosty,
	.submitonsty {
		width: 100% !important;
		height: 40px !important;
		padding: 0px !important;
		border: none !important;
		margin: 0px 0px !important;
		cursor: pointer !important;
		text-align: center !important;
		line-height: 40px !important;
		border-radius: 30px !important;
		background: rgba(78, 142, 255, 1) !important;
	}

	.submitsty>>>span,
	.submitwosty>>>span,
	.submitonsty>>>span {
		font-size: 14px !important;
		font-weight: 400 !important;
		line-height: 40px !important;
		color: rgba(255, 255, 255, 1) !important;
	}

	.btnfootsty .submitonsty,
	.btnfootsty .submitwosty {
		width: 150px !important;
		align-items: center !important;
	}

	.btnfootsty .submitonsty {
		background-color: #ffffff !important;
		border: 1px solid rgba(62, 136, 254, 1) !important;
	}

	.btnfootsty .submitonsty>>>span {
		color: rgba(62, 136, 254, 1) !important;
	}
</style>